import { render, staticRenderFns } from "./ProfitAndLossRecord.vue?vue&type=template&id=2b5d8481&"
import script from "./ProfitAndLossRecord.vue?vue&type=script&lang=js&"
export * from "./ProfitAndLossRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports